import { Filter } from '@/interfaces/filters/filter';
import { SettingObjectType } from '@/interfaces/settingObjectType';
import { SettingResource, settingResource } from '@/resources/setting.resource';
import { EntityModule } from './entity.module';
import group from './settingGroup.module';

/**
 * Moduł ustawień
 *
 * @export
 * @class SettingsModule
 * @extends {EntityModule<SettingObjectType, SettingResource>}
 */
export class SettingModule extends EntityModule<SettingObjectType, SettingResource> {
  public modules = { group };
  constructor() {
    super(settingResource);
    this.actions = {
      ...this.actions,
      /**
       * Pobiera listę encji
       *
       * @param context context
       * @param filters filtry listy
       */
      list: async (context: any, filters: Filter): Promise<void> => {
        const pagination = context.rootState.setting.group.id
          ? { ...filters, groupId: context.rootState.setting.group.id }
          : { ...filters, noGroup: true };

        const { list, count } = await this.resource.list(pagination);
        context.commit('saveList', list);
        context.commit('saveCount', count);
      }
    };
  }
}

export default new SettingModule();
